webpackJsonp([35783957827783],{

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic01.f6b41f6a.jpg";

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic02.6ee6b480.jpg";

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic03.7560cf85.jpg";

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic04.67d56340.jpg";

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic05.d82e6124.jpg";

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic06.05653d20.jpg";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "major" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "major" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Hi, my name is Jody"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "This is a collection of my most recent development projects, feel free to look around or contact me from the form below."
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "actions" },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "a",
	                            { href: "#one", className: "button next scrolly" },
	                            "My Projects"
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Banner;
	module.exports = exports["default"];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Banner = __webpack_require__(209);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _pic = __webpack_require__(515);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(516);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(134);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	var _pic7 = __webpack_require__(517);
	
	var _pic8 = _interopRequireDefault(_pic7);
	
	var _pic9 = __webpack_require__(518);
	
	var _pic10 = _interopRequireDefault(_pic9);
	
	var _pic11 = __webpack_require__(519);
	
	var _pic12 = _interopRequireDefault(_pic11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeIndex = function (_React$Component) {
	    _inherits(HomeIndex, _React$Component);
	
	    function HomeIndex() {
	        _classCallCheck(this, HomeIndex);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    HomeIndex.prototype.render = function render() {
	        var siteTitle = this.props.data.site.siteMetadata.title;
	        var siteDescription = this.props.data.site.siteMetadata.description;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    siteTitle
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: siteDescription })
	            ),
	            _react2.default.createElement(_Banner2.default, null),
	            _react2.default.createElement(
	                'div',
	                { id: 'main' },
	                _react2.default.createElement(
	                    'section',
	                    { id: 'one', className: 'tiles' },
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic2.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Gatsby-plugin-tawk'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'A simple plugin to add the Tawk js snippet to all pages of a gatsby site (including this one!)'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/gatsby-tawk', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic4.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Funny AF Tshirts'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'A fully functioning Static, Serverless, E-commerce site that uses Gatsby/React on Netlify and Stripe. '
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/funnyaftshirts', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic6.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'DemHats'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Coming Soon!'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/coming-soon', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic8.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Homesite'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'This very site! A Gatsby static site, using netlify hosting and forms.'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/homepage', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic10.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Coming soon'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Build it and they will come'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/coming-soon', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _pic12.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Liquid Democracy'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'A Platform to change the way citizens manage the politicians'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/coming-soon', className: 'link primary' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { id: 'two' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'More about me'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'When I\'m not coding, there\'s plenty of other life distractions I enjoy. '
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'actions' },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    _gatsbyLink2.default,
	                                    { to: '/about', className: 'button next' },
	                                    'More about me'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return HomeIndex;
	}(_react2.default.Component);
	
	exports.default = HomeIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-0f88aeb9bb50b68d7ba0.js